import config from 'config/common';
import { WNSTN_PROXY_FILEPATH } from '@leverate/common-client';

const WNSTN_PROXY_HOST = import.meta.env.REACT_APP_WNSTN_PROXY_HOST || config.api.URL;
export const WNSTN_FULL_PROXY_URL = `${WNSTN_PROXY_HOST}${WNSTN_PROXY_FILEPATH}`;

export const PROP_BOTTOM_NAV_HEIGHT = 68;

export const WNSTN_CLOSE_MESSAGE_TYPE = 'close_widget';
export const WNSTN_IFRAME_ORIGIN = 'https://reactapp.wnstn.ai';
